import { render, staticRenderFns } from "./ListadoPresupuestoProyeccionIngreso.vue?vue&type=template&id=ad1fbdf4"
import script from "./ListadoPresupuestoProyeccionIngreso.vue?vue&type=script&lang=js"
export * from "./ListadoPresupuestoProyeccionIngreso.vue?vue&type=script&lang=js"
import style0 from "./ListadoPresupuestoProyeccionIngreso.vue?vue&type=style&index=0&id=ad1fbdf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports